module.exports = __webpack_public_path__ + "media/application/images/svgs/youtube-d9f8dbeb2f898693996e7c244b56dbc0.svg";